import * as React from 'react';
import {
    ArrayInput,
    BooleanInput,
    BooleanField,
    Create,
    Edit,
    EditButton,
    FunctionField,
    List,
    ReferenceArrayInput,
    required,
    SelectArrayInput,
    SimpleForm,
    SimpleFormIterator,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';

const SettingsForm = () => (
    <>
        <TextInput
            source="name"
            label="Nom de la règle"
            helperText="Exemple : Guadeloupe, Martinique, PACA, Île-de-France..."
            validate={required()}
            fullWidth
        />

        <ReferenceArrayInput
            source="delivery_zone_ids"
            reference="boxdeliveryzone"
            label="Zones concernées"
            perPage={1000}
            validate={required()}
        >
            <SelectArrayInput
                optionText="name"
                helperText="Sélectionnez une ou plusieurs zones qui utiliseront cette règle."
            />
        </ReferenceArrayInput>

        <BooleanInput
            source="loyalty_offer_available"
            label="Offre fidélité Box disponible"
            helperText="Cette zone sera mentionnée dans l’offre -10 % affichée aux participants."
            defaultValue={false}
        />

        <TextInput
            source="notification_email"
            label="Email principal de notification"
            type="email"
            validate={required()}
            fullWidth
        />

        <ArrayInput
            source="notification_bcc"
            label="Emails en copie cachée (CCI)"
        >
            <SimpleFormIterator>
                <TextInput
                    source=""
                    label="Adresse email CCI"
                    type="email"
                    fullWidth
                />
            </SimpleFormIterator>
        </ArrayInput>
    </>
);

export const BoxSettingsList = (props) => (
    <List
        {...props}
        bulkActionButtons={false}
        perPage={50}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <TextField source="name" label="Règle" />

            <FunctionField
                label="Zones"
                render={(record: any) =>
                    `${Array.isArray(record.delivery_zone_ids)
                        ? record.delivery_zone_ids.length
                        : 0} zone(s)`
                }
            />

            <BooleanField
                source="loyalty_offer_available"
                label="Offre fidélité"
            />

            <TextField
                source="notification_email"
                label="Email principal"
            />

            <FunctionField
                label="CCI"
                render={(record: any) =>
                    `${Array.isArray(record.notification_bcc)
                        ? record.notification_bcc.length
                        : 0} adresse(s)`
                }
            />

            <EditButton />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxSettingsEdit = (props) => (
    <Edit
        {...props}
        mutationMode="optimistic"
        title="Routage des réservations Box"
    >
        <SimpleForm redirect="list">
            <SettingsForm />
        </SimpleForm>
    </Edit>
);

export const BoxSettingsCreate = (props) => (
    <Create {...props} title="Nouvelle règle de notification Box">
        <SimpleForm redirect="list">
            <SettingsForm />
        </SimpleForm>
    </Create>
);
